<template>
<div class='b-round-loader'
     :style='getWrapperStyle'>
    <span :style='getLoaderStyle'
          class='b-round-loader-inner'>
        <span :style='getLineStyle'
              class='b-round-loader-line'></span>
    </span>
</div>
</template>

<script lang='ts'>
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class RoundLoader extends Vue {
    @Prop({ type: Number, required: true }) readonly size!: number;
    @Prop({ type: Number, default: 3 }) readonly borderSize!: number;
    @Prop({ type: String, default: '#72B747' }) readonly borderColor!: string;
    @Prop({ type: Number, default: 1.2 }) readonly speed!: number;

    get getWrapperStyle() {
        return {
            width: this.sizePx,
            height: this.sizePx,
            animation: `loader-wrapper ${this.speed * 4}s linear infinite`,
        };
    }
    get getLoaderStyle() {
        return {
            width: this.sizePx,
            height: this.sizePx,
            clip: `rect(0, ${this.sizePx}, ${this.sizePx}, ${this.halfSizePx})`,
            animation: `loader-inner ${this.speed}s linear infinite`,
        };
    }
    get getLineStyle() {
        return {
            border: `${this.borderSizePx} solid ${this.borderColor}`,
            clip: `rect(0, ${this.sizePx}, ${this.sizePx}, ${this.halfSizePx})`,
            width: this.sizePx,
            height: this.sizePx,
            animation: `pseudo ${this.speed}s cubic-bezier(0.770, 0.000, 0.175, 1.000) infinite`,
        };
    }
    get sizePx() {
        return `${this.size}px`;
    }
    get halfSizePx() {
        return `${this.size / 2}px`;
    }
    get borderSizePx() {
        return `${this.borderSize}px`;
    }
};
</script>

<style lang='sass'>
@keyframes loader-wrapper
    0%
        transform: rotate(0deg)
    100%
        transform: rotate(360deg)

.b-round-loader-inner
    position: absolute
    display: block
    top: 0
    left: 0
    bottom: 0
    right: 0
    margin: auto

@keyframes loader-inner
    0%
        transform: rotate(0deg)
    100%
        transform: rotate(220deg)

.b-round-loader-line
    position: absolute
    top: 0
    left: 0
    bottom: 0
    right: 0
    margin: auto
    height: inherit
    width: inherit
    clip: inherit
    border-radius: 50%

@keyframes pseudo
    0%
        transform: rotate(-140deg)
    50%
        transform: rotate(-160deg)
    100%
        transform: rotate(140deg)
</style>
